"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = { name: "@video/log-client", version: "5.0.2" };
//# sourceMappingURL=package-json.js.map